import './index.scss';
import CustomConfig from 'models/CustomConfig';
import { ACCESS_TOKEN, CURRENT_IDENTIFIER } from 'utils/constants';
import includeBiobarDiv from 'setup/includeBiobarDiv';
import Cookies from 'universal-cookie';
import { updateCookieCurrentProduct } from 'utils/productCookies';

export function setupDevelopment() : CustomConfig {
  const config = {} as CustomConfig;
  config.inlineManualUrl = getInlineUrl('plannexo');
  config.includeNotifications = true;
  config.icons = [
    {
      iconName: 'info',
      tooltip: 'some tooltip',
      url: 'http://localhost:3000/'
    }
  ];
  config.dropdown = {
    tooltip: 'dropdown menu',
    iconName: 'settings',
    items: [
      { title: 'some title', url: 'http://localhost:3000/', updateBreadcrumb: true }
    ]
  };

  includeBiobarDiv();
  setDevelopmentCookies();
  setCompaniesCookie();

  return config;
}

function getInlineUrl(currentProduct : string) : string {
  switch(currentProduct) {
  case 'bionexo' :
    return 'https://inlinemanual.com/embed/player.f08d5dd5521ef3b10abc74c0f35a3e61.js';
  case 'bionfe' :
    return 'https://inlinemanual.com/embed/player.02062ebb75afba850362ea1c38da3b5f.js';
  case 'plannexo' :
    // eslint-disable-next-line
    const script = document.createElement('script');
    script.type = 'text/javascript';

    // eslint-disable-next-line
    // @ts-ignore
    script.innerHTML = window.inlineManualTracking={persona_bio_id:'undefined',persona_name:'undefined',persona_office:'undefined',persona_created_at:'undefined',company_name:'undefined',company_type:'undefined',company_id:'undefined',company_plan:'undefined'};window.inlineManualOptions={language:'pt'};
    // eslint-disable-next-line
    script.onload = (() => {
      document.getElementsByTagName('head')[0].appendChild(script);
    });

    return 'https://inlinemanual.com/embed/player.c1756355f1e62c235148347d6406b345.js';
  default :
    return '';
  }
}

function setDevelopmentCookies() : void {
  const cookieValue = process.env.REACT_APP_COOKIE_VALUE;

  const cookies = new Cookies();
  cookies.set(ACCESS_TOKEN, cookieValue);
  updateCookieCurrentProduct('Compras');
}

function setCompaniesCookie() : void {
  const cookieName = CURRENT_IDENTIFIER;

  if(!cookieName)
    return;

  const cookies = new Cookies();
  const identifier = !process.env.REACT_APP_BIOBAR_IMPERSONATE_IDENTIFIER_VALUE ?
    process.env.REACT_APP_BIOBAR_IDENTIFIER_VALUE :
    process.env.REACT_APP_BIOBAR_IMPERSONATE_IDENTIFIER_VALUE;

  cookies.set(cookieName, identifier);
}
